import { async } from '@angular/core/testing';
import { ReciboprecompraComponent } from './../reciboprecompra/reciboprecompra.component';
import { Empresa } from './../../models/empresa';
import { Precompra } from './../../models/precompra';
import { Component, OnInit, Inject, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';  // eta linea es para tranferir datos y cerrar dialog
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AsignafolioService } from 'src/app/services/asigafolios/asignafolio.service';
import { SolicitanteService } from 'src/app/services/solicitante/solicitante.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { EmailService } from 'src/app/services/email/email.service';


import { Solicpescador } from 'src/app/models/solicpescador';
import { environment } from 'src/environments/environment';
import { PrecompraService } from 'src/app/services/precompra.service';
import { MovimientospgosService } from 'src/app/services/movimientospgos.service';
import { Movimientopago } from 'src/app/models/movimientopgo';
import { MatDialog } from '@angular/material';
import { MensajeticketComponent } from '../mensajeticket/mensajeticket.component';
import { ModulomxService } from 'src/app/services/modulomx.service';
import { PgobancarioComponent } from '../pgobancario/pgobancario.component';
import { isNull } from 'util';




declare let paypal: any;


@Component({
  selector: 'app-precompras',
  templateUrl: './precompras.component.html',
  styleUrls: ['./precompras.component.css']
})
export class PrecomprasComponent implements OnInit, OnDestroy {
  @ViewChild('totaldolares', { static: true }) totaldolares: ElementRef;

  preciodia = 0;
  cantidades = 0;
  totalpagar = 0;
  idempresa = '';
  identificador = '';

  nombre = '';
  grantotalPagar = 0;
  emailempresa = '';
  telefono = '';
  idusuario = '';
  prioridad: number;
  archivoSubir: File;
  muestratransferencia: any;


  solicitante: Solicpescador;
  numeroConfirmacionStripe = '';
  folioconsecututivoEfectivo = '';
  nombreArchivoCreado = '';
  inventario = 0;


  // VARIABLES DE PAYPAL
  solicitudhtml = '';
  botondesabilitadopaso5 = true;
  conceptocompralander = '';
  addScript = false;
  paypalLoad = true;

  forma: FormGroup;

  cveusuario = '';
  emailusuario = '';
  nombrebarco = '';
  ultimoidprecompra = '';
  primervalorinventario = false;
  idinventarios = '';
  conceptolicencia="";
  concepto="";
  valor= null;
  conceptodecompra='';
  
  // --------------------

  suscemail: any;
  unsusprecompra: any;









  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<PrecomprasComponent>,
    private asignafolioService: AsignafolioService,
    private solicitanteService: SolicitanteService,
    private precompraService: PrecompraService,
    private movimientopgoService: MovimientospgosService,
    private loginUsuario: UsuarioService,
    private emailService: EmailService,
    private dialog: MatDialog,
    private modulomxService: ModulomxService,




  ) { }









  // proedimeinots d epaypal
  paypalConfig = {




    env: environment.seleccionPago,
    client: {
      sandbox: environment.apiSandbox,
      production: environment.apiProduccion
    },
    locale: 'en_US',
    style: {
      size: 'large',
      color: 'gold',
      shape: 'pill',
      label: 'pay',
      tagline: 'true',
      fundingicons: 'true',

    },







    commit: true,


    payment: (data, actions) => {





      return actions.payment.create({

        payment: {
          transactions: [
            {
              amount: { total: this.totalpagar, currency: 'USD' },
              description: 'Compra de permisos de Pesca de Día'
            }
          ]

        },

      });
      //
    },
    onAuthorize: (data, actions) => {
      return actions.payment.execute().then((payment) => {
        // Do something when payment is successful.


        this.numeroConfirmacionStripe = payment.id;
        // this.registraprecompra();

        this.adquisicionlicencia(this.numeroConfirmacionStripe);
        //esta se habilita para notofocar la compra de lotes
        this.enviaemail();

        // se carga los campos a la variable precompra
        // este modelo es para relizan compras dde permiso se carga en un tabla unica de las compras realizadas










      });
    }



  };

  getRndInteger(min: number, max: number) {
    return Math.floor(Math.random() * (max - min)) + min;
  }


  pagoscheques() {


    const dialogRefpgobancario = this.dialog.open(PgobancarioComponent, {
      panelClass: 'mensaje', width: '750px',
      disableClose: true,
      data: {

        costototal: this.totalpagar,

      }
    });

    dialogRefpgobancario.afterClosed().subscribe(
      data => {
        // this.unsususuarios = this.usuariosptesAceptacion();

        if (data.aceptado != "False") {
          console.log("**************", data)
          let numerocheque = data.numerocheque;
          let valoraleatorio: string = (this.getRndInteger(100, 100000)).toString();
          this.numeroConfirmacionStripe = "#CHEQUE-" + numerocheque + "/" + valoraleatorio;




          this.adquisicionlicencia(this.numeroConfirmacionStripe);
          //esta se habilita para notofocar la compra de lotes
          this.enviaemail();
        } else {
          alert("Operation Cancelled");
        }


      }
    );




















  }

  transferencias() {


    Swal.fire({
      title: 'Confirmation',
      text: "Click Yes to send your request." +
        "Please forward your bank transfer confirmation details to info@sportfishingmx.com to complete your transaction. Thank you.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {


        let valoraleatorio: string = (this.getRndInteger(100, 100000)).toString();
        this.numeroConfirmacionStripe = "Tranf-" + valoraleatorio;




        this.adquisicionlicencia(this.numeroConfirmacionStripe);
        //esta se habilita para notofocar la compra de lotes
        this.enviaemail();


      }
    })












  }



  ngAfterViewChecked(): void {
    if (!this.addScript) {

      this.addPaypalScript().then(() => {
        paypal.Button.render(this.paypalConfig, '#paypal-checkout-btn');
        this.paypalLoad = false;
        //     console.log ('deshabilitado porque no teine nada');
      });
    }
  }



  addPaypalScript() {
    this.addScript = true;
    //    console.log ('aqui nuevamene');
    return new Promise((resolve, reject) => {
      const scripttagElement = document.createElement('script');
      scripttagElement.src = 'https://www.paypalobjects.com/api/checkout.js';
      scripttagElement.onload = resolve;
      document.body.appendChild(scripttagElement);
    });
  }

  // ************************fin paypal


  enviaemail() {
    // const nombreArchivocompleto = this.nombreArchivoPDF;
    const subJet = this.nombre + ' ha realizado un deposito de $' + this.totalpagar + ' Dolares por concepto de la precompra de ' + this.cantidades + ' permisos de dia';
    console.log('**************', subJet)
    // const direccionemail = this.txtemail;
    //   const filepdf = nombreArchivocompleto;

    //  this.nombreArchivoPDF = filepdf;
    this.suscemail = this.emailService.sendEmailTuripes(subJet)
      .subscribe(
        licen => {
          // alert ('listo correo de compra enviado');
          // this.botonFinalizadeshabilitado = false;
        },

      );
  }



  ngOnDestroy() {

    this.unsusprecompra.unsubscribe();
  }

  ngOnInit() {
    
  
    this.nombre = this.loginUsuario.nombreempresa;
    this.preciodia = this.data.identificador;
    this.inventario = this.data.inventario;
    this.ultimoidprecompra = this.data.ultimoidprecompra;
    this.concepto= this.data.conceptolicencia;
    this.muestratransferencia= this.data.muestrabotontransferencia;
    if(this.muestratransferencia == undefined){
      this.muestratransferencia = true;
    } else {
      this.muestratransferencia = false;
    }

    if (this.concepto === null || this.concepto == undefined){
      this.conceptolicencia= "Compra de Licencias de Dia"
      this.conceptodecompra= 'Day License Purchase' ;
      this.concepto = "Day";
      
    } else {
      this.conceptolicencia= this.concepto + " License Purchase"  ;

      this.conceptodecompra=this.concepto + ' License Purchase' ;
      

      if (this.conceptolicencia.includes('Week')){
        this.valor="W";
      } else if (this.conceptolicencia.includes('Day')){
        this.valor="D";
      } else if (this.conceptolicencia.includes('Year')){
        this.valor="Y";
      }
      

    }

    // (document.getElementById('totalpagar') as HTMLInputElement).setAttribute('readonly','true');

    if (this.ultimoidprecompra == '0') {


      this.primervalorinventario = true;
    }

    console.log('identificador de precompra id:', this.ultimoidprecompra);
    // identificadorultimacompra

    this.idempresa = this.loginUsuario.idempresa;
    console.log('id empresa', this.idempresa);
    this.cveusuario = this.loginUsuario.usuarioLogin._id;


    // this.cveusuario = localStorage.getItem('id');
    this.emailusuario = this.loginUsuario.usuarioLogin.emailpersonal;
    this.emailempresa = this.loginUsuario.emailempresa;




    this.forma = new FormGroup({
      cantidades: new FormControl('0', Validators.required),
      totalpagar: new FormControl({ value: '0' }, Validators.required)

    });




  }




  cambiocantidad() {
    let total = this.cantidades * this.preciodia;
    this.totalpagar = total;

  }


  cerrarventana() {
    console.log('entre a procedimienot cerrrar evntaba');
    this.dialogRef.close({ aceptado: 'OK', cantidad: this.cantidades, monto: this.totalpagar, nuevoidprecompra: this.ultimoidprecompra, inventariototal: this.inventario });
  }

  cancelarventana() {
    this.dialogRef.close({ aceptado: 'False' });
  }
  // haremos esta documenatcion ficticia para granar cambio



  abrirmodalpgobancario() {

  }




  abrirmodal() {



    const dialogRef = this.dialog.open(ReciboprecompraComponent, {
      panelClass: 'mensaje',
      disableClose: true,
      data: {

        identificador: this.identificador,
      }
    });


    dialogRef.afterClosed().subscribe(
      data => {

        console.log('aqui termino');
        this.cerrarventana();

      }
    );

  }






  adquisicionlicencia(numeroconfirmacion: string) {


    this.asignafolioService.crearFolios()
      .subscribe(resp => {
        const fechaFolio = resp.fecha;
        const folioconsecutivo = resp.folioconsecutivo;
        this.folioconsecututivoEfectivo = fechaFolio.concat('-', folioconsecutivo);





        this.idinventarios = "22225";




        this.crearSolicitantes(numeroconfirmacion);

        //







      });






  }





  crearSolicitantes(numeroconfirmacion: string) {

   

   if (typeof(this.concepto) === "undefined"){
    this.valor= null
   }

    const precompra = new Precompra(
      this.cveusuario,
      this.idempresa,
      this.numeroConfirmacionStripe,
      this.conceptolicencia,
      this.cantidades,
      this.emailempresa,
      this.totalpagar,
      0,
      0,
      this.valor
    );

    // console.log('folio consecutivo', this.ultimoidprecompra);
     this.unsusprecompra = this.precompraService.crearprepago(precompra, this.ultimoidprecompra)
      .subscribe(valorprecompra => {


        // este localstore servira para saber el id del prepago y se usara para reportar el recibo
        //   console.log ('precompra realizada', valorprecompra);
        this.inventario = valorprecompra.disponibilidad;


        this.ultimoidprecompra = valorprecompra._id;  // aqui al actualziar al realizar un compra de licencias se recibe el
        // id de la iltima compra ya que el que se procesara simpre sera la ultima
        localStorage.setItem('idmovimiento', valorprecompra._id);
        this.identificador = valorprecompra._id;
        console.log('valor de compra', valorprecompra);

        let disponibilidad = 0;

        if (this.primervalorinventario) {
          disponibilidad = Number(this.cantidades);
        } else {

          // disponibilidad = Number(this.cantidades) + Number(valorprecompra.disponibilidad);
          disponibilidad = valorprecompra.disponibilidad;
        }

        console.log('disponibilidad', this.cantidades);
        console.log('disponibilidad2', valorprecompra.disponibilidad);
        console.log('cantuidades', disponibilidad);

        this.solicitante = new Solicpescador(this.nombre, this.emailempresa, null, this.cveusuario, null,
          this.folioconsecututivoEfectivo, true, 0,
          this.nombreArchivoCreado, this.folioconsecututivoEfectivo, null, null, this.conceptodecompra, true,
          numeroconfirmacion, true, this.cantidades, this.totalpagar, this.idempresa, this.ultimoidprecompra, true, true,);


        this.solicitanteService.crearsolicitanteypescador(this.solicitante, this.ultimoidprecompra).subscribe(resp => {

          const movimientopago = new Movimientopago(
            this.cveusuario,
            this.idempresa,
            valorprecompra._id,
            resp.idpescador,
            this.conceptodecompra,
            '',
            this.cantidades,
            0,
            0,
            disponibilidad,
            null,
            null,
            this.folioconsecututivoEfectivo,null,null,this.valor
          );

          this.movimientopgoService.crearmovimientospagos(movimientopago)
            .subscribe(nuevovalor => {
              //   console.log ('movimeintos nuevo vlor', nuevovalor);
              const valorrecibido = this.abrirmodal();

              this.modulomxService.compralicencias(this.idempresa, 'decompras');

              this.cerrarventana();

              //    if (this.inventario !== nuevovalor.movimiento.ldisponible) {
              //    alert ('fallo');
              //  }

            });
        });


      });













  }

  crearSolicitantesagencias(numeroconfirmacion: string) {



    const precompra = new Precompra(
      this.cveusuario,
      this.idempresa,
      this.numeroConfirmacionStripe,
      this.conceptolicencia,
      this.cantidades,
      this.emailempresa,
      this.totalpagar,
      0,
      0,
      this.valor
    );

    // console.log('folio consecutivo', this.ultimoidprecompra);
     this.unsusprecompra = this.precompraService.crearprepago(precompra, this.ultimoidprecompra)
      .subscribe(valorprecompra => {


        // este localstore servira para saber el id del prepago y se usara para reportar el recibo
        //   console.log ('precompra realizada', valorprecompra);
        this.inventario = valorprecompra.disponibilidad;


        this.ultimoidprecompra = valorprecompra._id;  // aqui al actualziar al realizar un compra de licencias se recibe el
        // id de la iltima compra ya que el que se procesara simpre sera la ultima
        localStorage.setItem('idmovimiento', valorprecompra._id);
        this.identificador = valorprecompra._id;
        console.log('valor de compra', valorprecompra);

        let disponibilidad = 0;

        if (this.primervalorinventario) {
          disponibilidad = Number(this.cantidades);
        } else {

          // disponibilidad = Number(this.cantidades) + Number(valorprecompra.disponibilidad);
          disponibilidad = valorprecompra.disponibilidad;
        }

        console.log('disponibilidad', this.cantidades);
        console.log('disponibilidad2', valorprecompra.disponibilidad);
        console.log('cantuidades', disponibilidad);

        this.solicitante = new Solicpescador(this.nombre, this.emailempresa, null, this.cveusuario, null,
          this.folioconsecututivoEfectivo, true, 0,
          this.nombreArchivoCreado, this.folioconsecututivoEfectivo, null, null, this.conceptodecompra, true,
          numeroconfirmacion, true, this.cantidades, this.totalpagar, this.idempresa, this.ultimoidprecompra, true, true);


        this.solicitanteService.crearsolicitanteypescador(this.solicitante, this.ultimoidprecompra).subscribe(resp => {

          const movimientopago = new Movimientopago(
            this.cveusuario,
            this.idempresa,
            valorprecompra._id,
            resp.idpescador,
            this.conceptodecompra,
            '',
            this.cantidades,
            0,
            0,
            disponibilidad,
            null,
            null,
            this.folioconsecututivoEfectivo,null,null,this.concepto.charAt(0)
          );

          this.movimientopgoService.crearmovimientospagos(movimientopago)
            .subscribe(nuevovalor => {
              //   console.log ('movimeintos nuevo vlor', nuevovalor);
              const valorrecibido = this.abrirmodal();

              this.modulomxService.compralicencias(this.idempresa, 'decompras');

              this.cerrarventana();

              //    if (this.inventario !== nuevovalor.movimiento.ldisponible) {
              //    alert ('fallo');
              //  }

            });
        });


      });













  }



}








